import { render, staticRenderFns } from "./GmapCustomMarker.vue?vue&type=template&id=bbd70c34"
import script from "./GmapCustomMarker.vue?vue&type=script&lang=js"
export * from "./GmapCustomMarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports